import { render } from "./BarChartLeft.vue?vue&type=template&id=41ddd6a8"
import script from "./BarChartLeft.vue?vue&type=script&lang=ts"
export * from "./BarChartLeft.vue?vue&type=script&lang=ts"
script.render = render

export default script